import * as yup from "yup";

export interface LupaPasswordFormValues {
    email: string;
}

export const lupaPasswordSchema = yup
    .object({
        email: yup
            .string()
            .email("Format email salah")
            .required("Kolom wajib diisi"),
    })
    .required();
